import React from 'react';
import cx from 'classnames';
import { nanoid } from 'nanoid';
import styled from 'styled-components';
import Image from 'next/image';
import styles from './testimonials.module.scss';
import TestimonialsProps from '../../models/testimonials';
import Richtext from '../global/richtext/Richtext';

type Props = {
  data: TestimonialsProps;
};

interface CProps {
  arrowLeft?: string;
  arrowRight?: string;
}

const CustomStyles = styled.div`
  .${styles.testimonials__story}:not(.${styles['testimonials__story--reverse']})
    .${styles.testimonials__text}>.${styles.testimonials__description}:first-of-type::before {
    background-image: url('${(p: CProps) => p.arrowRight}');
  }

  .${styles['testimonials__story--reverse']}
    .${styles.testimonials__text}>.${styles.testimonials__description}:first-of-type::after {
    background-image: url('${(p: CProps) => p.arrowLeft}');
  }
`;

const Testimonials = ({ data }: Props) => (
  <div className={styles.testimonials}>
    <CustomStyles
      arrowLeft={data.arrows.left ? data.arrows.left.src : ''}
      arrowRight={data.arrows.right ? data.arrows.right.src : ''}
    >
      {data.testimonials &&
        data.testimonials.map((s, i) => (
          <div
            key={nanoid()}
            className={cx(styles.testimonials__story, {
              [styles['testimonials__story--reverse']]: i % 2 === 0
            })}
          >
            {s.mainMedia && (
              <div
                className={cx(styles.testimonials__image, {
                  [styles['testimonials__image--mobile']]: s.secondaryMedia
                })}
              >
                <div className={styles['testimonials__image-wrapper']}>
                  <Image
                    alt={s.mainMedia.alt}
                    src={s.mainMedia.src}
                    layout="responsive"
                    width={s.mainMedia.width}
                    height={s.mainMedia.height}
                  />
                </div>
              </div>
            )}
            {s.secondaryMedia && (
              <div
                className={cx(
                  styles.testimonials__image,
                  styles['testimonials__image--desktop']
                )}
              >
                <div className={styles['testimonials__image-wrapper']}>
                  <Image
                    alt={s.secondaryMedia.alt}
                    src={s.secondaryMedia.src}
                    layout="responsive"
                    width={s.secondaryMedia.width}
                    height={s.secondaryMedia.height}
                  />
                </div>
              </div>
            )}
            {s.description && (
              <div className={styles.testimonials__text}>
                <Richtext
                  customClasses={{
                    container: styles.testimonials__description
                  }}
                  data={s.description}
                />
              </div>
            )}
          </div>
        ))}
    </CustomStyles>
  </div>
);

export default Testimonials;
